import { z } from 'zod';

/////////////////////////////////////////
// REPORT SCHEDULE SCHEMA
/////////////////////////////////////////

export const ReportScheduleSchema = z.object({
  reportscheduleId: z.number().int(),
  cityId: z.number().int(),
  personId: z.number().int(),
  emailFrequency: z.number().int(),
  emailDay: z.number().int(),
  reportId: z.number().int(),
  classificationId: z.number().int(),
  dataPeriod: z.number().int(),
  emailIfEmpty: z.number().int(),
})

export type ReportSchedule = z.infer<typeof ReportScheduleSchema>

export default ReportScheduleSchema;
